import apiConfig from './apiConfig';
import http from './http';

export async function getCountries() {
    return await http.get(apiConfig.get('countries'));
}

export function getFilters(countryCode) {
    return http.get(apiConfig.getWithId('filters', countryCode));
}

export function getByoData(data) {
    return http.post(apiConfig.get('byo'), data);
}


export function getTopTrendsData(data) {
    return http.post(apiConfig.get('top trends'), data);
}
export function getTopTrendsCopyTable(data) {
    return http.post(apiConfig.get('copy table'), data);
}

export function getFoodProfiles(countrycode) {
    return http.get(apiConfig.getWithId('food profiles', countrycode));
}

export function getFoodProfile(countryCode, id) {
    return http.get(apiConfig.getWithIds('food profile', [countryCode, id]));
}

export function getFoodProfileLTO(countryCode, id) {
    return http.get(apiConfig.getWithIds('food profile lto', [countryCode, id]));
}

export function getByoMenuExamples(data, tableParameters) {
    return http.post(apiConfig.get('byo menu examples'), {
        ...data,
        tableParameters,
    });
}

export function exportByoMenuExamples(data, tableParameters) {
    return http.post(apiConfig.get('export byo menu examples'), {
        ...data,
        customerFilter: {
            ...data.customerFilter,
            tableParameters,
        }
    });
}

export function getRestaurantsList(countryCode, restaurantListId) {
    return http.get(apiConfig.getWithIds('restaurant list', [countryCode, restaurantListId]));
}

export function getInstantChart(countryCode, instantChartId) {
    return http.get(apiConfig.getWithIds('instant chart', [countryCode, instantChartId]));
}

export function getRtuReports(id) {
    return http.get(apiConfig.getWithId('rtu reports', id));
}

export function getAdminAccess() {
    return http.get(apiConfig.get('admin access'))
}

export function getCustomRestaurantLists(countryCode) {
    return http.get( apiConfig.getWithIds('custom restaurant lists', [countryCode]));
}

export function getCustomRestaurantListsAvailableRestaurants(countryCode) {
    return http.get(apiConfig.getWithIds('custom restaurant lists', ["availableRestaurants", countryCode]));
}

export function getCustomRestaurantList(countryCode, id) {
    return http.get(apiConfig.getWithIds('custom restaurant lists', [countryCode, id]));
}

export function requestAccess(countryCode, toolLocation) {
    return http.post(apiConfig.get('request access flavor'), { countryCode, toolLocation });
}

export function getCategoryReports(countryCode) {
    return http.get(apiConfig.getWithId('category reports', countryCode));
}

export function fetchGetCategoriesFastestGrowing (countryCode) {
    return http.get(apiConfig.getWithId('categories fastest growing', countryCode));
}

export function fetchCountryStates(countryCode) {
    return http.get(apiConfig.getWithId('country states', countryCode));
}

export function fetchMenuExamples(data) {
    return http.post(apiConfig.get('menu examples'), data);
}

export function exportMenuExamples(data) {
    return http.post(apiConfig.get('export menu examples'), data);
}

export async function instantChartGetNameById(id) {
    return http.get(apiConfig.get('instant charts get name by id').replace(':id', id));
}

export async function byoSettingGetNameById(id) {
    return http.get(apiConfig.get('byo settings get name by id').replace(':id', id));
}
